import valueInEdit from './ValueInEdit';

export default {
  edit: {
    value: valueInEdit,
  },
  show: {},
  list: {},
};
